import {
  Component,
  EventEmitter,
  OnInit,
  OnDestroy,
  Output,
  QueryList,
  ViewChildren,
  ViewChild,
  ViewEncapsulation,
  TemplateRef,
} from "@angular/core";
import {
  search,
  infoCircle,
  VAIconRegistryService,
} from "@va/core-library/icons";
import { forkJoin, Subject, Subscription } from "rxjs";
import { debounceTime, distinctUntilChanged } from "rxjs/operators";
import { PharmaDataService } from "../pharma-data.service";
import { FacetFilter, extraInfoKeys } from "../pharma-page.model";
import { NzTreeComponent } from "ng-zorro-antd/tree";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import {
  FilterEventChanged,
  UpdatePills,
} from "src/app/store/actions/pharma-page.actions";
import { ChartFilters } from "src/app/store/models/charts-page.model";
import { Dictionary } from "highcharts";
import {FacetTreeFilterComponent} from "../facet-tree-filter/facet-tree-filter.component";

@Component({
  selector: "app-database-page-facet",
  templateUrl: "./database-page-facet.component.html",
  styleUrls: ["./database-page-facet.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class DatabasePageFacetComponent implements OnInit, OnDestroy {
  inputFacetFilter;
  @Output() facetFilterChanged: EventEmitter<any> = new EventEmitter();
  @ViewChildren(NzTreeComponent) nzTreeComponents!: QueryList<NzTreeComponent>;
  @ViewChildren(FacetTreeFilterComponent) facetTreeFilterComponents!: QueryList<FacetTreeFilterComponent>;

  facetFilter: FacetFilter = new FacetFilter();
  lastFacetFilter: FacetFilter = new FacetFilter();
  panels = [];
  facetData = {};
  facetSearch = "";
  facetCategorySearch = {};
  cachedSelections = {};
  terminatedSwitch: boolean = false;
  placeholderValues: { [key: string]: string } = {};
  isAdditionalFilterEnabled = false;
  lastCachedSelections = {
    ticker: {},
    therapeutic_area: {},
    phase: {},
    api: {},
    drug: {},
    indication: [],
    moa: [],
    drug_class: [],
    target: [],
    geo: [],
    commercial_status: [],
    drug_type: [],
    delivery_mechanism: [],
  };
  dataCallSubscription: Subscription;
  facetSearchSubscription: Subscription;
  facetCategorySearchSubscription: Subscription;
  pharmaDatabasePageSubscriber: Subscription;
  loading = false;
  activePanel = "";
  refreshCurrentPanel = false;
  
  inputChartFilter: ChartFilters;
  appliedChartFilters: any = {};
  facetSearchChange: Subject<string> = new Subject<string>();
  facetCategorySearchChange: Subject<any> = new Subject<any>();
  searchResultOptions = {};
  searching = false;
  gridSettings;
  advancedFilterPanels= [
    {
      name: "Launch Year",
      active: false,
      key: "launch_year",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Parent Co - Market Cap",
      active: false,
      key: "market_cap",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    },
    {
      name: "Parent Co: Rating",
      active: false,
      key: "rating",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    },
    {
      name: "Approval Date",
      active: false,
      key: "approval_date",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Peak Sales",
      active: false,
      key: "peak_sales",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Drug Type",
      active: false,
      key: "drug_type",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    // {
    //   name: "Drug Class",
    //   active: false,
    //   key: "drug_class",
    //   isTree: true,
    //   treeIndex: 4,
    //   useVirtualScroll: true,
    //   showCount: true,
    //   showSearch: true,
    // }, 
    {
      name: "Route Of Admin",
      active: false,
      key: "delivery_mechanism",
      isTree: true,
      treeIndex: 5,
      useVirtualScroll: true,
      showCount: true,
      showSearch: true,
    }, 
    {
      name: "Expiry Date",
      active: false,
      key: "expiry_date",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Drug Revenue",
      active: false,
      key: "drug_revenue",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Parent Co. Financials",
      active: false,
      key: "parent_co_financials",
      useVirtualScroll: false,
      showCount: false,
      showSearch: false,
    }, 
    {
      name: "Parent Co: Valuation Ratios",
      active: false,
      key: "valuation_ratios",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    }, 
    {
      name: "Parent Co: Price Target Consensus",
      active: false,
      key: "price_target",
      useVirtualScroll: false,
      showCount: true,
      showSearch: false,
    },
  ]
  // tabsArray: [
  //   {
  //     label: "Top Level Filters",
  //     isDisabled: false,
  //     isHidden: false,
  //     isLazyLoaded: false,
  //     contentTemplate: "basicFilters"
  //   },
  //   {
  //     label: "Advanced Filters",
  //     isDisabled: false,
  //     isHidden: false,
  //     contentTemplate: "advancedFilters",
  //     isLazyLoaded: false
  //   },
  //   {
  //     label: "Third",
  //     labelTemplate: null,
  //     isDisabled: false,
  //     isHidden: false,
  //     isLazyLoaded: false,
  //     content: "I don't have template"
  //   }
  // ]
  HIERARCHY_CATEGORIES = new Set(["indication", "moa", "drug_class", "target"]);
  constructor(
    private dataService: PharmaDataService,
    private iconRegistryService: VAIconRegistryService,
    private store: Store<AppState>,
  ) {
    this.iconRegistryService.registerIcons([search, infoCircle]);
  }

  ngOnInit() {
    this.panels = [
      {
        name: "Indication",
        active: false,
        key: "indication",
        isTree: true,
        useVirtualScroll: false,
        treeIndex: 0,
        showCount: true,
        showSearch: true,
      },
      {
        name: "Clinical Phases (by Indication)",
        active: false,
        key: "phase",
        showCount: true,
        showSearch: false,
      },
      {
        name: "Drug Commercial Status",
        active: false,
        key: "commercial_status",
        isTree: true,
        treeIndex: 1,
        useVirtualScroll: false,
        showCount: true,
        showSearch: false,
      },
      {
        name: "MOA",
        active: false,
        key: "moa",
        isTree: true,
        treeIndex: 2,
        useVirtualScroll: true,
        showCount: true,
        showSearch: true,
      },
      {
        name: "Target",
        active: false,
        key: "target",
        isTree: true,
        treeIndex: 3,
        showCount: true,
        showSearch: true,
        useVirtualScroll: true,
      },
      {
        name: "Geography",
        active: false,
        key: "geo",
        showCount: true,
        showSearch: false,
      },
      {
        name: "Company",
        active: false,
        key: "ticker",
        useVirtualScroll: true,
        showCount: true,
        showSearch: true,
      },
      {
        name: "Therapeutic Area",
        active: false,
        key: "therapeutic_area",
        showCount: true,
        showSearch: true,
        useVirtualScroll: true,
      },
      {
        name: "API",
        active: false,
        key: "api",
        useVirtualScroll: true,
        showCount: true,
        showSearch: true,
      },
      {
        name: "Drug Name",
        active: false,
        key: "drug",
        useVirtualScroll: true,
        showCount: false,
        showSearch: true,
      },
    ];

    this.panels.forEach((panel) => {
      this.placeholderValues[panel.key] = `Search ${panel.name}`;
    });
    this.advancedFilterPanels.forEach((panel) => {
      this.placeholderValues[panel.key] = `Search ${panel.name}`;
    });
    this.dataService.onGlobalGridSettings.subscribe((resp) => {
      const prevGrid = this.gridSettings
        ? JSON.parse(JSON.stringify(this.gridSettings))
        : this.gridSettings;
      const latestGrid = resp ? JSON.parse(JSON.stringify(resp)) : resp;
      this.updateFacetOnGridChange(prevGrid, latestGrid);
    });
    this.pharmaDatabasePageSubscriber = this.store
      .select(stateGetter("pharmaDatabasePage"))
      .subscribe((data: any) => {
        this.inputChartFilter = data.chartFilters;
        this.facetFilter = FacetFilter.fromJson(data.facetFilters);
        this.lastFacetFilter = FacetFilter.fromJson(data.lastFacetFilter);
        if (data.filterEvent.filterChanged === "chart") {
          // update facets
          this.chartFilterChanged(
            this.inputChartFilter,
            data.pillsData.extraInfo,
          );
          return;
        }
        if (
          data.filterEvent.filterChanged === "facet" &&
          data.filterEvent.source === "default"
        ) {
          this.panels.forEach((p) => {
            this.facetCategorySearch[p.key] = "";
            this.facetData[p.key] = this.facetData[`${p.key}_org`];
          });
          this.facetCategorySearch["drug_class"] = "";
          this.facetCategorySearch["delivery_mechanism"] = "";
          this.advancedFilterPanels.forEach((p) => {
            // this.facetCategorySearch[p.key] = "";
            this.facetData[p.key] = this.facetData[`${p.key}_org`];
          });

          this.callFacetApis(
            this.getFacetApiCalls(this.facetFilter, this.dataService.defaultCurrency),
            true,
            false,
            false,
            data.pillsData.extraInfo.fromQueryFilter
              ? null
              : data.pillsData.extraInfo,
          );
          this.lastFacetFilter = FacetFilter.fromJson(this.facetFilter.toDTO());
          this.lastCachedSelections = JSON.parse(
            JSON.stringify(this.cachedSelections),
          );
          return;
        }
        if (
          data.filterEvent.filterChanged === "pill" &&
          data.filterEvent.source === "delete"
        ) {
          const tagInfo = data.filterEvent.pillInfo;
          let category = tagInfo["key"];
          const id = tagInfo["id"];
          if (category === "company_id") {
            category = "ticker";
          }
          const panel = this.panels.find((p) => p.key === category);
          if (panel) {
            if (panel.isTree) {
              this.facetFilter[tagInfo["key"]].delete(id);
              const cachedSelectionsCopy = { ...this.cachedSelections };
              cachedSelectionsCopy[panel.key] = cachedSelectionsCopy[
                panel.key
              ].filter((data) => data !== id);
              this.cachedSelections = JSON.parse(
                JSON.stringify(cachedSelectionsCopy),
              );
            } else {
              this.facetFilter[tagInfo["key"]].delete(id);
              const cachedSelectionsCopy = { ...this.cachedSelections };
              delete cachedSelectionsCopy[panel.key][id];
              this.cachedSelections = JSON.parse(
                JSON.stringify(cachedSelectionsCopy),
              );
            }
          }
          this.callFacetApis(
            this.getFacetApiCalls(this.facetFilter),
            false,
            true,
            false,
            data.pillsData.extraInfo,
          );
          this.lastFacetFilter = FacetFilter.fromJson(this.facetFilter.toDTO());
          this.lastCachedSelections = JSON.parse(
            JSON.stringify(this.cachedSelections),
          );
          // fire pill delete event
          return;
        }
        if (
          data.filterEvent.source === "saved-filter" ||
          data.filterEvent.source === "search" ||
          data.filterEvent.source === "new-search"
        ) {
          const facetfilter = FacetFilter.fromJson(data.facetFilters);
          this.facetFilter = facetfilter;
          this.callFacetApis(
            this.getFacetApiCalls(this.facetFilter),
            true,
            false,
            false,
            data.pillsData.extraInfo.fromQueryFilter
              ? null
              : data.pillsData.extraInfo,
          );
          this.lastFacetFilter = FacetFilter.fromJson(this.facetFilter.toDTO());
          this.lastCachedSelections = JSON.parse(
            JSON.stringify(this.cachedSelections),
          );
          return;
        }
      });

    if (this.facetSearchSubscription) {
      this.facetSearchSubscription.unsubscribe();
    }
    this.facetSearchSubscription = this.facetSearchChange
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe((keyword) => {
        keyword = keyword.trim();
        this.dataService.logUserAction("ALL_FACET_SEARCH", {
          query_string: keyword,
        });
        if (keyword.length >= 3) {
          this.searchAllFacetFilters(keyword);
          this.searching = false;
        } else {
          this.searchResultOptions = {};
        }
        this.searching = false;
      });

    if (this.facetCategorySearchSubscription) {
      this.facetCategorySearchSubscription.unsubscribe();
    }
    this.facetCategorySearchSubscription = this.facetCategorySearchChange
      .pipe(debounceTime(500), distinctUntilChanged())
      .subscribe(({ panel, value }) => {
        value = value.trim();
        this.dataService.logUserAction("FACET_CATEGORY_SEARCH", {
          query_string: value,
          category: panel.key,
        });
        if (value.length >= 3) {
          this.searchFacetCategory(panel, value);
        } else {
          this.facetData[panel.key] = this.facetData[`${panel.key}_org`];
        }
      });
  }

  onSwitchChange(event: boolean): void {
    //Terminated/Discontinued has hardcoded id 7 in BE.
    // this.activePanel = "include_terminated";
    this.activePanel = "phase";
    this.refreshCurrentPanel = !event;
    this.facetFilter.include_terminated = event;
    if (!this.facetFilter.include_terminated) {
      if (this.facetFilter.phase.has(7)) {
        this.facetFilter.phase.delete(7);
      }
      if (this.facetFilter.commercial_status.has(7)) {
        this.facetFilter.commercial_status.delete(7);
        this.facetData["commercial_status"][2].selected = false;
        this.facetData["commercial_status"][2].checked = false;
        this.cachedSelections = {
          ...this.cachedSelections,
          commercial_status: this.cachedSelections["commercial_status"].filter(
            (data) => data !== 7,
          ),
        };
      }
    }
    this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
    this.lastFacetFilter = JSON.parse(
      JSON.stringify(FacetFilter.fromJson(this.facetFilter.toDTO())),
    );
    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "facet",
        source: "include_terminated",
        data: {
          facetFilters: this.facetFilter.toDTO(),
          extraInfo: this.dataService.getPharmaStateExtraInfo(
            extraInfoKeys,
            this.cachedSelections,
          ),
        },
      }),
    );
  }

  chartFilterChanged(chartFilters, pillExtraInfo) {
    this.removeChartFilters();
    this.applyChartFilters(chartFilters, pillExtraInfo);
    this.appliedChartFilters = { ...chartFilters };
    this.callFacetApis(this.getFacetApiCalls(this.facetFilter), false, true);
  }

  onExpandChange(obj) {
    let {param, panel} = obj;
    //This is to circumvent a weird issue with nzTree. reference HIVE-4322
    param.node.canHide = false;
    // param.node.children.forEach((_) => _.canHide = false)
    if (
      param.node.isExpanded &&
      this.facetCategorySearch[panel.key] &&
      this.facetCategorySearch[panel.key].length >= 3
    ) {
      //TODO: check if nzTreeComponents is still accessible
      this.facetTreeFilterComponents.toArray()[panel.treeIndex].nzTreeComponent.nzSearchValue =
        this.facetCategorySearch[panel.key];
    }
  }

  updateFacetSelection() {
    this.cachedSelections = {
      ...this.cachedSelections,
      ticker: {},
      therapeutic_area: {},
      phase: {},
      api: {},
      drug: {},
      indication: [],
      moa: [],
      drug_class: [],
      target: [],
      geo: [],
      commercial_status: [],
      drug_type: {},
      delivery_mechanism: {},
    };
    for (const category in this.facetFilter.toDTO()) {
      if(category === "peak_sales" || category === "drug_revenue" || category === "approval_date" 
        || category === "expiry_date" || category === "launch_year" || category === "drug_type" || category === "parent_co_financials"
        || category === "valuation_ratios" || category === "price_target" || category === "market_cap" || category === "rating") 
        { 
          //  nothing to do
        }
      else if (this.facetFilter[category].size > 0) {
        let key = category;
        if (category === "company_id") {
          key = "ticker";
        }
        const panel = this.panels.find((p) => p.key === key);

        const categoryData = this.facetData[`${key}_org`].filter((val) => {
          return this.facetFilter[category].has(val.value);
        });

        if (panel.isTree) {
          this.cachedSelections[key] = Array.from(this.facetFilter[category]);
          const res = [];
          this.searchHierarchyById(
            this.facetData[`${key}_org`],
            Array.from(this.facetFilter[category]),
            res,
            0,
          );
          res.forEach((data) => {
            if (!this.cachedSelections[`${key}_data`]) {
              this.cachedSelections[`${key}_data`] = {};
            }
            this.cachedSelections = {
              ...this.cachedSelections,
              [`${key}_data`]: {
                ...this.cachedSelections[`${key}_data`],
                [data.value]: data.title,
              },
            };
          });
        } else {
          categoryData.forEach((data) => {
            this.cachedSelections[key][data.value] = true;
            if (!this.cachedSelections[`${key}_data`]) {
              this.cachedSelections[`${key}_data`] = {};
            }
            this.cachedSelections = {
              ...this.cachedSelections,
              [`${key}_data`]: {
                ...this.cachedSelections[`${key}_data`],
                [data.value]: data.label,
              },
            };
            // this.cachedSelections[`${key}_data`][data.value] = data.label;
          });
        }
      }
    }
  }

  onOptionSelect(panel: any, option: any) {
    this.activePanel = panel.key;
    panel.active = true;
    let key = panel.key;
    if (panel.key === "ticker") {
      key = "company_id";
    }
    if (panel.isTree) {
      this.facetFilter[key].add(option.value);
      this.cachedSelections[panel.key].push(option.value);
    } else {
      this.facetFilter[key].add(option.value);
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          [panel.key]: { ...[panel.key], [option.value]: true },
        }),
      );
    }
    this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
    this.lastFacetFilter = FacetFilter.fromJson(this.facetFilter.toDTO());
    this.lastCachedSelections = JSON.parse(
      JSON.stringify(this.cachedSelections),
    );

    if (!this.cachedSelections[`${panel.key}_data`]) {
      this.cachedSelections[`${panel.key}_data`] = {};
    }
    this.cachedSelections[`${panel.key}_data`] = {
      ...this.cachedSelections[`${panel.key}_data`],
      [option["value"]]: option["label"],
    };

    //Workaround for tree categories which do not reflect selections without a rerender
    if (panel.isTree && panel.key === this.activePanel) {
      this.activePanel = "";
      setTimeout(() => {
        this.activePanel = panel.key;
      }, 0);
    }

    this.facetSearch = "";
    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "facet",
        source: panel.key,
        data: {
          facetFilters: this.facetFilter.toDTO(),
          extraInfo: this.dataService.getPharmaStateExtraInfo(
            extraInfoKeys,
            this.cachedSelections,
          ),
        },
      }),
    );
  }

  onActiveChange() {
    this.panels.forEach((p) => {
      this.facetCategorySearch[p.key] = "";
      this.facetData[p.key] = this.facetData[`${p.key}_org`];
    });
  }

  onFacetSearch(event) {
    if (event.key === "Enter") {
      return;
    }
    this.searching = true;
    this.facetSearchChange.next(this.facetSearch);
  }

  onFacetCategorySearch(panel: any) {
    if (!panel.isTree) {
      this.facetCategorySearchChange.next({
        panel,
        value: this.facetCategorySearch[panel.key],
      });
    } else {
      this.dataService.logUserAction("FACET_CATEGORY_SEARCH", {
        query_string: this.facetCategorySearch[panel.key],
        category: panel.key,
      });
    }
  }

  searchAllFacetFilters(query: string) {
    query = query.toLowerCase();

    this.panels.forEach((panel) => {
      let res = [];
      if (panel.isTree) {
        //Fill res through reference using recursion
        this.searchFlattenedHierarchicalFacet(
          this.facetData[`${panel.key}_org`],
          query,
          panel.showCount,
          res,
        );
      } else {
        if (panel.key === "drug") {
          res = this.searchDrugWithAlias(
            this.facetData[`${panel.key}_org`],
            query,
          );
        } else {
          res = this.searchSingleValueFacet(
            this.facetData[`${panel.key}_org`],
            query,
            panel.showCount,
          );
        }
      }

      if (res.length) {
        this.searchResultOptions[panel.name] = res;
      } else {
        delete this.searchResultOptions[panel.name];
      }
    });

    this.searchResultOptions = { ...this.searchResultOptions };
    if (Object.keys(this.searchResultOptions).length === 0) {
      this.dataService.logUserAction("ALL_FACET_SEARCH_EMPTY", {
        query_string: query,
      });
    }
  }

  searchFacetCategory(panel: any, query: string) {
    query = query.toLowerCase();

    let res = [];
    if (panel.key === "drug") {
      res = this.searchDrugWithAlias(this.facetData[`${panel.key}_org`], query);
    } else {
      res = this.searchSingleValueFacet(
        this.facetData[`${panel.key}_org`],
        query,
        panel.showCount,
      );
    }

    if (res.length) {
      this.facetData[panel.key] = res;
    } else {
      this.facetData[panel.key] = [];
      this.dataService.logUserAction("FACET_CATEGORY_SEARCH_EMPTY", {
        query_string: query,
        category: panel.key,
      });
    }
  }

  searchSingleValueFacet(
    categoryData: Array<any>,
    query: string,
    withCount: boolean,
  ) {
    const res = categoryData.filter((data) => {
      if (withCount) {
        return (
          data["count"] > 0 &&
          (data["label"].toLowerCase().includes(query) ||
            (data["fullname"] &&
              data["fullname"].toLowerCase().includes(query)))
        );
      }
      return (
        data["label"].toLowerCase().includes(query) ||
        (data["fullname"] && data["fullname"].toLowerCase().includes(query))
      );
    });
    return res;
  }

  searchDrugWithAlias(drugData: Array<any>, query: string) {
    const res = [];
    drugData.forEach((data) => {
      if (data["label"].toLowerCase().includes(query)) {
        res.push({
          value: data.value,
          label: data.label,
        });
      } else {
        //If drug name doesn't match, try with alias name
        const aliases = data["alias"] ? data["alias"].split(";") : [];
        const matchingAlias = aliases.find((alias) =>
          alias.toLowerCase().includes(query),
        );
        if (matchingAlias) {
          res.push({
            value: data.value,
            label: data.label,
            alias: matchingAlias,
            isAlias: true,
          });
        }
      }
    });

    return res;
  }

  // searchHierarchicalFacet(
  //   hierachicalData: Array<any>,
  //   query: string
  // ) {
  //     let myRes = [];

  //     hierachicalData.forEach((data) => {
  //       const childRes = this.searchHierarchicalFacet(data["children"], query);

  //       if (childRes.length) {
  //         myRes.push({
  //           ...data,
  //           expanded: true,
  //           children: childRes
  //         });
  //       } else {
  //         if (data["title"].toLowerCase().includes(query)) {
  //           myRes.push({
  //             ...data,
  //             children: []
  //           });
  //         }
  //       }
  //     })

  //     return myRes;
  // }

  searchHierarchyById(
    hierarchicalData: Array<any>,
    ids: Array<number>,
    res: Dictionary<any>,
    count: number,
  ) {
    if (count === ids.length) {
      return;
    }
    for (let i = 0; i < hierarchicalData.length; i++) {
      const obj = hierarchicalData[i];
      if (ids.includes(obj["key"])) {
        res.push(obj);
        count++;
      }
      if (obj.children && obj.children.length) {
        this.searchHierarchyById(obj.children, ids, res, count);
      }
    }
  }

  searchFlattenedHierarchicalFacet(
    hierarchicalData: Array<any>,
    query: string,
    withCount: boolean,
    cache: Array<any>,
  ) {
    hierarchicalData.forEach((data) => {
      if (withCount) {
        if (data["count"] > 0 && data["key"].toLowerCase().includes(query)) {
          cache.push({
            value: data.value,
            label: data.key,
            count: data.count,
          });
        } else {
          //Dont process children if the parent itself is has no count
          if (data["count"] === 0) {
            return;
          }
        }
      } else {
        if (data["key"].toLowerCase().includes(query)) {
          cache.push({
            value: data.value,
            label: data.key,
          });
        }
      }
      if (data.children && data.children.length > 0) {
        this.searchFlattenedHierarchicalFacet(
          data.children,
          query,
          withCount,
          cache,
        );
      }
    });
  }

  removeChartFilters() {
    const chartFilters = this.appliedChartFilters;
    if (chartFilters["company_id"]) {
      this.cachedSelections["ticker"][chartFilters["company_id"]] = false;
    }
    if (chartFilters["therapeutic_area"]) {
      this.cachedSelections["therapeutic_area"][
        chartFilters["therapeutic_area"]
      ] = false;
    }
    if (chartFilters["phase"]) {
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          phase: {
            ...this.cachedSelections["phase"],
            [chartFilters["phase"]]: false,
          },
        }),
      );
    }
    if (chartFilters["indication"]) {
      //Chart filter clear scnario. Rmove last entry
      //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          indication: this.cachedSelections["indication"].slice(0, -1),
        }),
      );
    }
    if (chartFilters["moa"]) {
      //Chart filter clear scnario. Rmove last entry
      //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter

      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          moa: this.cachedSelections["moa"].slice(0, -1),
        }),
      );
    }

    if (chartFilters["target"]) {
      //Chart filter clear scnario. Rmove last entry
      //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter

      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          target: this.cachedSelections["target"].slice(0, -1),
        }),
      );
    }

    if (chartFilters["commercial_status"]) {
      //Chart filter clear scnario. Rmove last entry
      //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter

      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          target: this.cachedSelections["commercial_status"].slice(0, -1),
        }),
      );
    }

    if (chartFilters["geo"]) {
      //Chart filter clear scnario. Rmove last entry
      //Always the last entry will be chart filter since applying facet filter from UI will wipe out chart filter

      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          target: this.cachedSelections["geo"].slice(0, -1),
        }),
      );
    }
  }

  applyChartFilters(chartFilters, pillExtraInfo) {
    if (chartFilters["company_id"]) {
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          ticker: {},
        }),
      );
      this.cachedSelections["ticker"][chartFilters["company_id"]] = true;
      this.cachedSelections["ticker_data"] = { ...pillExtraInfo.ticker_data };
    }
    if (chartFilters["phase"]) {
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          phase: {},
        }),
      );
      this.cachedSelections["phase"][chartFilters["phase"]] = true;
      this.cachedSelections["phase_data"] = { ...pillExtraInfo.phase_data };
    }
    if (chartFilters["indication"]) {
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          indication: [],
        }),
      );
      this.cachedSelections["indication"].push(chartFilters["indication"]);
      this.cachedSelections["indication_data"] = {
        ...pillExtraInfo.indication_data,
      };
    }
    if (chartFilters["moa"]) {
      this.cachedSelections = JSON.parse(
        JSON.stringify({
          ...this.cachedSelections,
          moa: [],
        }),
      );
      this.cachedSelections["moa"].push(chartFilters["moa"]);
      this.cachedSelections["moa_data"] = { ...pillExtraInfo.moa_data };
    }
  }

  getFilterPayload(facetFilter, currency?) {
    return {
      filter: facetFilter.toDTO(),
      revenue_type: this.gridSettings
        ? this.gridSettings.options.data.revenue_type
        : "total_revenue",
      currency: currency || this.gridSettings?.options?.data?.currency,
    };
  }
  getFacetApiCalls(facetFilter, currency?) {
    const filter = this.getFilterPayload(facetFilter);
    return [
      this.dataService.getFacetData(filter),
      this.dataService.getIndicationFacetData(filter),
      this.dataService.getMoaFacetData(filter),
      this.dataService.getDrugClassFacetData(filter),
      this.dataService.getTargetFacetData(filter),
      this.dataService.getAdvancedFacetData(filter),
      // this.dataService.getValuationRatioFacetData(filter),
      // this.dataService.getValuationRatioFacetGraphData(filter),
    ];
  }

  callFacetApis(
    apiCalls,
    isRouteChangeCall?,
    updateSelections?,
    withWatchlist?,
    pillExtraInfo?,
  ) {
    //withWatchlist will always be false since it is out of scope for v1 release. Keeping it for future
    withWatchlist = false;
    if (withWatchlist) {
      apiCalls.push(this.dataService.getWatchlists());
    }

    if (this.dataCallSubscription) {
      this.dataCallSubscription.unsubscribe();
    }

    this.loading = true;

    this.dataCallSubscription = forkJoin(apiCalls).subscribe((resp) => {
      // ==================================== START =====================================
      // Remove this section once facet.biopharma_screener_access is removed.
      let drugClassFilterPanel = {
        name: "Drug Class",
        active: false,
        key: "drug_class",
        isTree: true,
        treeIndex: 4,
        useVirtualScroll: true,
        showCount: true,
        showSearch: true,
      };
      const facet = resp[0] as any;
      this.isAdditionalFilterEnabled = facet.biopharma_screener_access;
      if(this.isAdditionalFilterEnabled) {
        this.advancedFilterPanels.push(drugClassFilterPanel);
      } else {
        this.panels.push(drugClassFilterPanel);
      }
      this.placeholderValues[drugClassFilterPanel.key] = `Search ${drugClassFilterPanel.name}`;
      // =============================== END =====================================
      this.panels.forEach((panel) => {
        // Check panel key is not commercial_status
        if (panel.key !== "commercial_status") {
          this.facetData[panel.key] =
            panel.key === this.activePanel && !this.refreshCurrentPanel
              ? this.facetData[panel.key]
              : facet.data && facet.data[panel.key]
                ? facet.data[panel.key]
                : [];
          if (panel.key !== this.activePanel) {
            this.facetData[`${panel.key}_org`] = this.facetData[panel.key];
          }
        }
      });

      const commercialStatusFacet = facet.data["commercial_status"];
      this.facetData["commercial_status"] =
        "commercial_status" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["commercial_status"]
          : commercialStatusFacet
            ? this.mapTreeData(commercialStatusFacet)
            : this.facetData["commercial_status"];
      this.facetData["commercial_status_org"] =
        this.facetData["commercial_status"];

      const indicationFacet = resp[1] as any;
      this.facetData["indication"] =
        "indication" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["indication"]
          : indicationFacet.data
            ? this.mapTreeData(indicationFacet.data.values)
            : this.facetData["indication"];
      this.facetData["indication_org"] = this.facetData["indication"];

      const moaFacet = resp[2] as any;
      this.facetData["moa"] =
        "moa" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["moa"]
          : moaFacet.data
            ? this.mapTreeData(moaFacet.data.values)
            : this.facetData["moa"];
      this.facetData["moa_org"] = this.facetData["moa"];

      const drugClassFacet = resp[3] as any;
      this.facetData["drug_class"] =
        "drug_class" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["drug_class"]
          : drugClassFacet.data
            ? this.mapTreeData(drugClassFacet.data.values)
            : this.facetData["drug_class"];
      this.facetData["drug_class_org"] = this.facetData["drug_class"];

      const targetFacet = resp[4] as any;
      this.facetData["target"] =
        "target" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["target"]
          : targetFacet.data
            ? this.mapTreeData(targetFacet.data.values)
            : this.facetData["target"];
      this.facetData["target_org"] = this.facetData["target"];
      const advancedFilterFacet = resp[5] as any;
      // const valuationRatioFilterData = resp[6] as any;
      // const valuationRatioGraphData = resp[7] as any;
      this.setAdvancedFilterData(advancedFilterFacet);
      // this.setValuationRatioFilterData(valuationRatioFilterData, valuationRatioGraphData);
      if (withWatchlist) {
        const watchlists = resp[6] as any;
        const watchlistData: [] = watchlists.data.map((wl) => {
          return {
            label: wl.watchername,
            value: wl.watchername,
            isWatchlist: true,
            company_id: wl.company_info.map((_) => _.companyid),
          };
        });

        if (watchlistData.length) {
          this.facetData["ticker"] = watchlistData.concat(
            this.facetData["ticker"],
          );
        }
      }
      this.loading = false;
      this.activePanel = "";
      this.refreshCurrentPanel = false;
      if (isRouteChangeCall || updateSelections) {
        this.updateFacetSelection();
        if (pillExtraInfo) {
          this.cachedSelections = {
            ...this.cachedSelections,
            ...pillExtraInfo,
          };
        }
        this.store.dispatch(
          new UpdatePills({
            facetFilter: this.facetFilter.toDTO(),
            extraInfo: this.dataService.getPharmaStateExtraInfo(
              extraInfoKeys,
              this.cachedSelections,
            ),
          }),
        );
      }
    });
  }

  // setValuationRatioFilterData(valuationRatioFilterData, graphData) {
  //   this.facetData["valuation_ratios"] = valuationRatioFilterData.data || {};
  //   this.facetData["valuation_ratios"].ratio = graphData?.data?.ratio;
  //   this.facetData["valuation_ratios"].no_of_companies = graphData?.data?.no_of_companies;
  //   this.facetData["valuation_ratios"].min = graphData?.data?.min;
  //   this.facetData["valuation_ratios"].max = graphData?.data?.max;

  //   // this.facetData["valuation_ratios"] = ;
  //   this.facetData["valuation_ratios_org"] = this.facetData["valuation_ratios"];
  // }

  setAdvancedFilterData(advancedFilterFacet) {
    this.facetData["peak_sales"] = advancedFilterFacet.peak_sales;
    this.facetData["peak_sales_org"] = this.facetData["peak_sales"];
    this.facetData["drug_revenue"] = advancedFilterFacet.drug_revenue;
    this.facetData["drug_revenue"]["drug_revenues"].splice(0,1);
    this.facetData["drug_revenue_org"] = this.facetData["drug_revenue"];
    this.facetData["approval_date"] = advancedFilterFacet.approval_date;
    this.facetData["approval_date_org"] = this.facetData["approval_date"];
    this.facetData["expiry_date"] = advancedFilterFacet.expiry_date;
    this.facetData["expiry_date_org"] = this.facetData["expiry_date"];
    this.facetData["launch_year"] = advancedFilterFacet.launch_year;
    this.facetData["launch_year_org"] = this.facetData["launch_year"];
    this.facetData["market_cap"] = advancedFilterFacet.market_cap;
    this.facetData["market_cap_org"] = this.facetData["market_cap"];
    this.facetData["rating"] = advancedFilterFacet.rating;
    this.facetData["rating_org"] = this.facetData["rating"];
    this.facetData["drug_type"] = advancedFilterFacet.drug_type;
    this.facetData["drug_type_org"] = this.facetData["drug_type"];
    this.facetData["delivery_mechanism"] =
        "delivery_mechanism" === this.activePanel && !this.refreshCurrentPanel
          ? this.facetData["delivery_mechanism"]
          : advancedFilterFacet.delivery_mechanism
            ? this.mapTreeData(advancedFilterFacet.delivery_mechanism)
            : this.facetData["delivery_mechanism"];
      
    this.facetData["delivery_mechanism_org"] = this.facetData["delivery_mechanism"];
    this.facetData["parent_co_financials"] = this.mapParentCoFinancials(advancedFilterFacet.parent_co_financials);
    this.facetData["parent_co_financials_org"] = this.facetData["parent_co_financials"];
    this.facetData["valuation_ratios"] = advancedFilterFacet.valuation_ratios;
    this.facetData["valuation_ratios_org"] = this.facetData["valuation_ratios"];
    this.facetData["price_target"] = advancedFilterFacet.price_target;
    this.facetData["price_target_org"] = this.facetData["price_target"];

  }

  mapParentCoFinancials(financials) {
    return  {
      meta: {
        currency: financials?.meta?.currency,
        label: financials?.meta?.label,
        magnitude: financials?.meta?.magnitude,
        defaultItem: financials?.meta?.default_item,
        defaultyear: financials?.meta?.default_year,
        lineItemList: financials?.meta?.line_item_list,
        yearList: financials?.meta?.year_list,
        minMaxCombinations: financials?.meta?.min_max_combinations
      }
    }
  }
  mapTreeData(data: Array<any>) {
    if (!data || !data.length) {
      return [];
    }
    const res = data.map((d) => {
      if (d.count === 0) {
        d.disabled = true;
        d.disableCheckbox = true;
      }
      return {
        ...d,
        title: `${d.title}`,
        children: this.mapTreeData(d.children),
      };
    });

    return res;
  }

  onOptionChange(obj) {
    let {category, options} = obj;
    this.activePanel = category;
    let key = category;
    if (key === "ticker") {
      key = "company_id";
    }
    if (this.cachedSelections[category][options.value] !== undefined) {
      this.cachedSelections[category][options.value] =
        !this.cachedSelections[category][options.value];
    } else {
      this.cachedSelections = {
        ...this.cachedSelections,
        [category]: {
          ...this.cachedSelections[category],
          [options.value]: true,
        },
      };
    }
    if (this.cachedSelections[category][options.value]) {
      this.facetFilter[key].add(options["value"]);
    } else {
      this.panels = this.panels.map((panel) => {
        if (panel.key === category) {
          return {
            ...panel,
            allSelected: false,
          };
        }
        return panel;
      });
      this.facetFilter[key].delete(options["value"]);
    }
    this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
    this.lastFacetFilter = JSON.parse(
      JSON.stringify(FacetFilter.fromJson(this.facetFilter.toDTO())),
    );

    if (!this.cachedSelections[`${category}_data`]) {
      this.cachedSelections[`${category}_data`] = {};
    }
    this.cachedSelections[`${category}_data`] = {
      ...this.cachedSelections[`${category}_data`],
      [options["value"]]: options["label"],
    };

    this.lastCachedSelections = JSON.parse(
      JSON.stringify(this.cachedSelections),
    );

    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "facet",
        source: category,
        data: {
          facetFilters: this.facetFilter.toDTO(),
          extraInfo: this.dataService.getPharmaStateExtraInfo(
            extraInfoKeys,
            this.cachedSelections,
          ),
        },
      }),
    );
  }

  onHierarchyOptionChange(obj) {
    let {category, option} = obj;
    this.activePanel = category;
    this.cachedSelections = JSON.parse(
      JSON.stringify({ ...this.cachedSelections, [category]: option.keys }),
    );
    this.facetFilter[category] = new Set(option.keys);
    // if (option.keys.length !== this.facetData[`${category}_org`].length) {
    //   this.panels = this.panels.map((panel) => {
    //     if (panel.key === category) {
    //       return {
    //         ...panel,
    //         allSelected: false
    //       };
    //     }
    //     return panel;
    //   });
    // }

    this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
    this.lastFacetFilter = JSON.parse(
      JSON.stringify(FacetFilter.fromJson(this.facetFilter.toDTO())),
    );

    if (!this.cachedSelections[`${category}_data`]) {
      this.cachedSelections[`${category}_data`] = {};
    }
    const dataObj = {};
    for (let i = 0; i < option.checkedKeys.length; i++) {
      const node = option.checkedKeys[i];
      const key = node.origin.key;
      const value = node.origin.title;
      dataObj[key] = value;
    }

    this.cachedSelections[`${category}_data`] = {
      ...this.cachedSelections[`${category}_data`],
      ...dataObj,
    };

    this.lastCachedSelections = JSON.parse(
      JSON.stringify(this.cachedSelections),
    );
    // TODO: fire similar dispatch on change of advanced filters
    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "facet",
        source: category,
        data: {
          facetFilters: this.facetFilter.toDTO(),
          extraInfo: this.dataService.getPharmaStateExtraInfo(
            extraInfoKeys,
            this.cachedSelections,
          ),
        },
      }),
    );
  }

  onAdvancedFilterChange(obj) {
    let {activePanel, cachedSelections, facetFilter, category} = obj;
    this.activePanel = activePanel;
    this.cachedSelections = cachedSelections;
    this.facetFilter = facetFilter;

    this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
    this.lastFacetFilter = JSON.parse(
      JSON.stringify(FacetFilter.fromJson(this.facetFilter.toDTO())),
    );
    this.lastCachedSelections = JSON.parse(
      JSON.stringify(this.cachedSelections),
    );

    this.store.dispatch(
      new FilterEventChanged({
        filterChanged: "facet",
        source: category,
        data: {
          facetFilters: this.facetFilter.toDTO(),
          extraInfo: this.dataService.getPharmaStateExtraInfo(
            extraInfoKeys,
            this.cachedSelections,
          ),
        },
      }),
    );
  }
  updateFacetOnGridChange(prevGrid, latestGrid) {
    if (
      latestGrid &&
      prevGrid &&
      latestGrid.options &&
      latestGrid.options.data &&
      prevGrid.options &&
      prevGrid.options.data
    ) {
      if (
        latestGrid.options.data.revenue_type !==
        prevGrid.options.data.revenue_type
      ) {
        this.gridSettings = latestGrid;
        this.callFacetApis(this.getFacetApiCalls(this.facetFilter));
        return;
      }
      if(latestGrid.options.data.currency !==
        prevGrid.options.data.currency) {
          if(latestGrid.options.data.currency === "") {
            this.disableAmoutFieldsInAdvancedFilter();
          }
          const filter = this.getFilterPayload(this.facetFilter)
          this.dataService.getAdvancedFacetData(filter).subscribe((resp) => {
            this.setAdvancedFilterData(resp);
          });
        // forkJoin([
        //   this.dataService.getValuationRatioFacetData(filter),
        //   this.dataService.getValuationRatioFacetGraphData({
        //     selected_ratio: this.facetFilter.valuation_ratios?.ratio,
        //     selected_year: this.facetFilter.valuation_ratios?.year,
        //   }),
        // ]).subscribe((resp) => {
        //   this.setValuationRatioFilterData(resp[0], resp[1]);
        // })
        
      }
    }
    this.gridSettings = latestGrid;
  }

  disableAmoutFieldsInAdvancedFilter() {
    this.facetData["peak_sales"] = {
      ...this.facetData["peak_sales"],
      sale_currency: "",
    };
  }
  updateGraph(revenueData) {
    let filter = new FacetFilter();
    let payload = {
      filter: filter.toDTO(),
      "filter_screen_type": "drug_revenue"
    };
    payload.filter.drug_revenue = revenueData;
    this.dataService.getAdvancedFacetData(payload).subscribe((response) => {
      // Handle response as needed, e.g. update data or emit event
      this.facetData["drug_revenue"] = response?.data?.drug_revenue;
      this.facetData["drug_revenue"]["drug_revenues"].splice(0,1);
      this.facetData["drug_revenue_org"] = this.facetData["drug_revenue"];
      
    });
  }
  ngOnDestroy() {
    if (this.dataCallSubscription) {
      this.dataCallSubscription.unsubscribe();
    }
    if (this.facetSearchSubscription) {
      this.facetSearchSubscription.unsubscribe();
    }
    if (this.facetCategorySearchSubscription) {
      this.facetCategorySearchSubscription.unsubscribe();
    }
    if (this.pharmaDatabasePageSubscriber) {
      this.pharmaDatabasePageSubscriber.unsubscribe();
    }
  }
}
